<template>
    <v-card class="pa-3" height="100%">
        <apexchart
        type="pie"
        height="360"
        :options="chart.projectBudget.options"
        :series="chart.projectBudget.series"
        ></apexchart>
    </v-card>
</template>
<script>
  import { mapGetters } from "vuex";  
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      apexchart: VueApexCharts,
    },
  data: () => ({
      chart: {
        projectBudget: {
            series: [],
            options: {
                title: {
                text: "Projects Budget Overview",
                },
                noData: {
                text: "No data available",
                },
                chart: {
                type: "pie",
                toolbar: {
                    show: true,
                },
                },
                labels: ["Paid Amount", "Unpaid Amount",],
                colors: [
                "#71974c",  
                "#00a0de",
                ],
                legend: {
                show: true,
                position: "bottom",
                },
            },
        },
      }

    }),

    created() {
      // this.initialize();
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["project-budget"]);
        this.updateCharts();
      },

      async updateCharts() {

        let fetched_data = this.indexData.series;
        this.chart.projectBudget.series = [1].concat(Array(fetched_data.length).fill(0));
        
        setTimeout(() => {
          this.chart.projectBudget.series = fetched_data;
        }, 500);
      }
    }

  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>